var InheritedBlock = SirTrevor.Blocks.FeaturedPages;

SirTrevor.Blocks.FeaturedPages = (function(){
  return SirTrevor.Blocks.FeaturedPages.extend({
    /****** Stuff From orinal page_block js ******/
    type: "featured_pages",

    icon_name: "pages",

    show_image_selection: false,

    /****** Autocomplete Customizations ******/
    sidebarEl: false, // The checkbox for whether sidebar shows or not.
    limit: 5, // How many feature pages can show?
    acInput: false, // The autocomplete input element.
    warning: "This feature row is at the maximum number of items.",
    warningEl: false, // The warning's element.



    /**
     * Builds the warning div, and puts it after the autocomplete.
     */
    makeWarningEl: function() {
      this.warningEl = $("<p>" + this.warning + "</p>");
      this.acInput.after(this.warningEl);
    },

    /**
     * Sets the limit, based on the sidebar.
     */
    setLimit: function() {
      if(this.sidebarEl === false) {
        this.sidebarEl = $('#feature_page_display_sidebar');
      }

      this.limit = $(this.sidebarEl).is(':checked') ? 3 : 5;
    },

    /**
     * Hide or show the autocomplete input.
     *
     * @param {boolean} full
     *   Are we full on panels yet?
     */
    toggleAutocomplete: function(full) {
      if(full) {
        this.acInput.hide();
        this.warningEl.show();
      } else {
        this.acInput.show();
        this.warningEl.hide();
      }
    },

    /**
     * Rechecks if block is full and hides/shows autocomplete.
     * Optionally resets limit too.
     *
     * @param {boolean} resetLimit
     *  Whether or not to reset the limit.
     */
    resetAc: function(resetLimit) {
      if(typeof resetLimit !== undefined) {
        this.setLimit();
      }

      // Counts the items in the block and compares to limit.
      var full = ($('li.dd-item', this.inner).length >= this.limit);

      this.toggleAutocomplete(full);
    },

    /**
     * Overwrites Spotlight.Blocks.Resource::onBlockRender.
     * Shows/Hides the autocomplete box based on sidebar and number of panels.
     */ 
    onBlockRender: function() {
      InheritedBlock.prototype.onBlockRender.call(this);

      this.acInput = $('auto-complete', this.inner);
      this.makeWarningEl();
      this.resetAc(true);

      // If sidebar selection changes, reset autocomplete.
      this.sidebarEl.on("change", function() {
        this.resetAc(true);
      }.bind(this));
    },

    /**
     * Overwrites Spotlight.Blocks.Resource::afterPanelRender.
     * Shows/Hides the autocomplete box based on sidebar and number of panels.
     */
    afterPanelRender: function(data, panel) {
      // Don't run during page load. Wait until block is fully rendered.
      if(this.acInput) {
        // Code was firing before panel html was actually in the DOM.
        window.setTimeout(this.resetAc.bind(this), 100);
      }
    },

    /**
     * Overwrites Spotlight.Blocks.Resource::afterPanelDelete.
     */
    afterPanelDelete: function() {
      this.resetAc();
    }


  }); // End extend Spotlight.Block.Resources.
})();
